import React,{useState} from 'react';
import {Link,useLocation} from 'react-router-dom';
import {motion,AnimatePresence} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {useCMS} from '../../context/CMSContext';

const {FiMenu,FiX,FiChevronDown}=FiIcons;

const Header=()=> {
  const [isMenuOpen,setIsMenuOpen]=useState(false);
  const [isServicesOpen,setIsServicesOpen]=useState(false);
  const location=useLocation();
  const {content}=useCMS();

  const navigation=[ 
    {name: 'Accueil',href: '/'},{name: 'Services',href: '/services',submenu: [ 
      {name: 'Assainissement',href: '/services/assainissement'},{name: 'Hygiène',href: '/services/hygiene'},{name: 'Contrôle Pollution',href: '/services/controle-pollution'},{name: 'Formation',href: '/services/formation'},{name: 'Support QHSE',href: '/services/support-qhse'},
    ],},{name: 'À propos',href: '/about'},{name: 'Contact',href: '/contact'},
  ];

  return ( 
    <header className="fixed top-0 left-0 right-0 z-50"> 
      <div className="relative z-10 bg-white/90 backdrop-blur-md shadow-md"> 
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8"> 
          <div className="flex justify-between items-center py-3 lg:py-4"> 
            <Link to="/" className="flex items-center flex-shrink-0"> 
              {content.company.logo ? ( 
                <img src={content.company.logo} alt={content.company.name} className="h-16 md:h-20 w-auto object-contain rounded-lg" style={{transform: 'scale(0.85)'}} /> 
              ) : ( 
                <span className="text-lg md:text-2xl font-bold text-gray-900"> 
                  {content.company.name} 
                </span> 
              )} 
            </Link> 
            <nav className="hidden xl:flex items-center space-x-2 2xl:space-x-6"> 
              {navigation.map((item)=> ( 
                <div key={item.name} className="relative group"> 
                  {item.submenu ? ( 
                    <> 
                      <Link to={item.href} className="flex items-center space-x-1 text-gray-700 hover:text-gold-500 font-medium transition-colors py-2 text-sm 2xl:text-base" > 
                        <span>{item.name}</span> 
                        <motion.div animate={{rotate: isServicesOpen ? 180 : 0}} transition={{duration: 0.2}} > 
                          <SafeIcon icon={FiChevronDown} className="w-4 h-4" /> 
                        </motion.div> 
                      </Link> 
                      <AnimatePresence> 
                        <motion.div className="absolute top-full left-0 mt-2 w-48 bg-white/95 backdrop-blur-md rounded-lg shadow-xl border border-gray-100 py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" initial={{opacity: 0,y: 10}} animate={{opacity: 1,y: 0}} exit={{opacity: 0,y: 10}} transition={{duration: 0.2}} > 
                          {item.submenu.map((subItem)=> ( 
                            <Link key={subItem.name} to={subItem.href} className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-gold-500 transition-colors font-medium" > 
                              {subItem.name} 
                            </Link> 
                          ))} 
                        </motion.div> 
                      </AnimatePresence> 
                    </> 
                  ) : ( 
                    <Link to={item.href} className={`font-medium transition-colors py-2 text-sm 2xl:text-base ${location.pathname===item.href ? 'text-gold-500' : 'text-gray-700 hover:text-gold-500'}`} > 
                      {item.name} 
                    </Link> 
                  )} 
                </div> 
              ))} 
              <Link to="/contact" className="bg-gradient-to-r from-gold-500 to-yellow-400 text-gray-900 px-4 py-2 rounded-lg font-medium hover:shadow-lg transition-all text-sm 2xl:text-base ml-2" > 
                Devis 
              </Link> 
            </nav> 
            <button onClick={()=> setIsMenuOpen(!isMenuOpen)} className="xl:hidden p-2 rounded-lg text-gray-700 hover:text-gold-500 flex-shrink-0" > 
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" /> 
            </button> 
          </div> 
          <AnimatePresence> 
            {isMenuOpen && ( 
              <motion.div initial={{opacity: 0,height: 0}} animate={{opacity: 1,height: 'auto'}} exit={{opacity: 0,height: 0}} className="xl:hidden border-t border-gray-200 py-4 max-h-[calc(100vh-80px)] overflow-y-auto" > 
                {navigation.map((item)=> ( 
                  <div key={item.name} className="py-1"> 
                    <Link to={item.href} className="block py-2 px-4 text-gray-700 hover:text-gold-500 font-medium text-sm" onClick={()=> setIsMenuOpen(false)} > 
                      {item.name} 
                    </Link> 
                    {item.submenu && ( 
                      <div className="pl-6 space-y-1 bg-gray-50"> 
                        {item.submenu.map((subItem)=> ( 
                          <Link key={subItem.name} to={subItem.href} className="block py-2 px-4 text-xs text-gray-600 hover:text-gold-500" onClick={()=> setIsMenuOpen(false)} > 
                            {subItem.name} 
                          </Link> 
                        ))} 
                      </div> 
                    )} 
                  </div> 
                ))} 
                <div className="py-2 px-4 border-t border-gray-200 mt-2"> 
                  <Link to="/contact" className="block w-full bg-gradient-to-r from-gold-500 to-yellow-400 text-gray-900 px-4 py-2 rounded-lg font-medium hover:shadow-lg transition-all text-center text-sm" onClick={()=> setIsMenuOpen(false)} > 
                    Demander un devis 
                  </Link> 
                </div> 
              </motion.div> 
            )} 
          </AnimatePresence> 
        </div> 
      </div> 
    </header> 
  );
};

export default Header;